/**
 * External dependencies
 */
import React from "react";
import { Box, Text } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import "./styles.scss";

const SettingRow = ({ label, altDescription, children }) => {
  return (
    <Box className="settings-row" padding="large" display="flex">
      <Box className="settings-row__label-container" marginRight="medium">
        <label>
          <Text size="xsmall" weight="medium">
            {label}
          </Text>
        </label>
      </Box>
      <Box flex="grow">
        <Box>{children}</Box>
        <Box>
          <p>
            <Text size="xsmall">{altDescription}</Text>
          </p>
        </Box>
      </Box>
    </Box>
  );
};

SettingRow.defaultProps = {};

export default SettingRow;
